import React from 'react';
import { Button, Modal } from 'gatorcomponents';
import * as Styles from './ChangeDomainBlockModal.styles';
import useLocale from '@/hooks/useLocale';

const ChangeDomainBlockModal = ({ onClose }) => {
  const { changeDomain: changeDomainLocale } = useLocale();
  const { changeDomainBlockModal: locale } = changeDomainLocale;

  const handleOnClose = () => {
    onClose && onClose();
  };
  return (
    <Modal
      open
      onClose={handleOnClose}
      title={locale.title}
    >
      <Styles.Content>{locale.description}</Styles.Content>
      <Styles.ButtonWrapper>
        <Button
          variant="primary"
          width="fit-content"
          size="medium2"
          label={locale.buttonLabel}
          onClick={handleOnClose}
        />
      </Styles.ButtonWrapper>
    </Modal>
  );
};

export default ChangeDomainBlockModal;
